import './OtherSharedDocumentList.scss';
import {useCallback, useState} from "react";
import momentTimezone from "moment-timezone";
import BackComponent from "../../../shared/components/back/BackComponent";
import {CommonService} from "../../../shared/services";
import {useNavigate} from "react-router-dom";
import CardComponent from "../../../shared/components/card/CardComponent";
import SelectDropdownComponent from "../../../shared/components/form-controls/select-dropdown/SelectDropdownComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import moment from "moment";
import TableWrapperComponent from "../../../shared/components/table-wrapper/TableWrapperComponent";
import {APIConfig} from "../../../constants";
import LinkComponent from "../../../shared/components/link/LinkComponent";
import {ITableColumn} from "../../../shared/models/table.model";
import ModalComponent from "../../../shared/components/modal/ModalComponent";
import FacilityDetailsComponent from "../facility-details/FacilityDetailsComponent";
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import DateRangePickerComponentV2 from "../../../shared/components/date-range-pickerV2/DateRangePickerComponentV2";

interface OtherSharedDocumentListProps {

};

const columns: ITableColumn[] = [
    {
        title: 'Title',
        key: 'title',
        dataIndex: 'title',
        width: 300,
    },
    {
        title: 'Document Date',
        key: 'document_date',
        dataIndex: 'document_date',
        width: 200,
        render: (record: any) => {
            return <>{moment(record.document_date).format('DD-MMM-YYYY')}</>
        }
    },
    {
        title: 'Document Type',
        key: 'document_type',
        dataIndex: 'document_type',
        width: 250,
        render: (record: any) => {
            return <>{record.file_type}</>
        }
    },
    {
        title: 'Provider Name',
        key: 'attached_by',
        dataIndex: 'attached_by',
        width: 300,
        sortable: true,
        render: (record: any) => {
            return <>{record.attached_by_details?.first_name}{' '}{record.attached_by_details?.last_name}</>
        }
    },
    {
        title: "Action",
        key: "view_details",
        dataIndex: "view_details",
        align: "center",
        fixed: "right",
        // width: 25,
        width: 200,
        render: (record: any) => {
            return (
                <LinkComponent route={''}>
                    View Details
                </LinkComponent>
            );
        }
    },
]

const OtherSharedDocumentList = (props: OtherSharedDocumentListProps) => {

    const navigate = useNavigate();
    const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false);
    const [otherSharedDocumentsFilterState, setOtherSharedDocumentsFilterState] = useState<any>({
        timezone: momentTimezone.tz.guess(),
        document_type_id: undefined,
        sort: {},
        date_range: [null, null],
        start_date: null,
        end_date: null
    });
    const {
        documentFileTypeList,
        isDocumentFileTypesListLoaded,
        isDocumentFileTypesListLoading,
    } = useSelector((state: IRootReducerState) => state.staticData);

    const navigateToClientCases = useCallback(() => {
        navigate(CommonService._routeConfig.ClientCases());
    }, [navigate]);

    const handleSort = useCallback((key: string, order: string) => {
        setOtherSharedDocumentsFilterState((oldState: any) => {
            const newState = {...oldState};
            newState["sort"] = {
                key,
                order
            }
            return newState;
        })
    }, []);


    return (
        <div className={'other-shared-document-list'}>
            <div className="list-screen__header">
                <div className="list-screen__header-title">
                    <BackComponent onClick={navigateToClientCases}/>
                </div>
                <div className={'contact-number-wrapper'}>
                    <div className={'contact-message'}>For any questions or concerns, please <span
                        onClick={() => setIsContactUsModalOpen(true)}
                        className={'contact-us'}>contact us.</span></div>
                </div>
            </div>
            <CardComponent className={'other-shared-document-card'}>
                <div className={'filter-wrapper'}>
                    <div className={'ts-row'}>
                        <div className={'ts-col-lg-3 other-shared-document-heading'}>
                            Other Shared Documents
                        </div>
                        <div className={'ts-col-lg-4'}/>
                        <div className={'ts-col-lg-2'}>
                            <SelectDropdownComponent
                                size={"small"}
                                fullWidth={true}
                                placeholder={"Document Type"}
                                options={documentFileTypeList}
                                value={otherSharedDocumentsFilterState.document_type_id}
                                displayWith={(option: any) => option.type}
                                valueExtractor={(option: any) => option._id}
                                isClearable={true}
                                isDataLoading={isDocumentFileTypesListLoading}
                                isDataLoaded={isDocumentFileTypesListLoaded}
                                onUpdate={(value: any) => {
                                    setOtherSharedDocumentsFilterState({
                                        ...otherSharedDocumentsFilterState,
                                        document_type_id: value
                                    });
                                }}
                            />
                        </div>
                        <div className={'ts-col-lg-3'}>
                            <DateRangePickerComponentV2
                                value={otherSharedDocumentsFilterState?.date_range}
                                onDateChange={(value: any) => {
                                    setOtherSharedDocumentsFilterState((prevState: any) => {
                                        if (value) {
                                            return {
                                                ...prevState,
                                                start_date: moment(value[0]).format('YYYY-MM-DD'),
                                                end_date: moment(value[1]).format('YYYY-MM-DD'),
                                                date_range: value,
                                                timezone: momentTimezone.tz.guess()
                                            };
                                        } else {
                                            const {date_range, start_date, end_date, ...rest} = prevState;
                                            return rest;
                                        }
                                    });
                                }}
                            />
                        </div>
                    </div>
                </div>
                <TableWrapperComponent url={APIConfig.OTHER_SHARE_DOCUMENTS.URL}
                                       method={APIConfig.OTHER_SHARE_DOCUMENTS.METHOD}
                                       extraPayload={otherSharedDocumentsFilterState}
                                       onSort={handleSort}
                                       noDataText={'No documents have been shared.'}
                                       columns={columns}/>
            </CardComponent>

            <ModalComponent isOpen={isContactUsModalOpen}
                            closeOnBackDropClick={true}
                            modalFooter={<ButtonComponent color={'accent'} className={'mrg-bottom-30 mrg-top-10'}
                                                          onClick={() => setIsContactUsModalOpen(false)}>
                                Close
                            </ButtonComponent>}
                            onClose={() => setIsContactUsModalOpen(false)}>
                <FacilityDetailsComponent title={'Contact Us'}/>
            </ModalComponent>
        </div>
    )
}

export default OtherSharedDocumentList;
